/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.addEventListener("DOMContentLoaded", () => {
  const selectors = [
    ".product-without-no_wishlist .gw-wl-add-to-wishlist-placeholder",
    ".product-without-no_wishlist .gw-add-to-wishlist-product-card-placeholder",
    ".product-without-no_wishlist .qview-button-wrapper",
  ];

  selectors.forEach((selector) => {
    document.querySelectorAll(selector).forEach((el) => el.remove());
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const gwpConfig = window.themeVariables?.gwp;

  if (!gwpConfig?.vipAccessRequired) {
    return;
  }

  const rawVipParam = (gwpConfig.vipParam || "").trim();

  if (!rawVipParam || !rawVipParam.includes("=")) {
    return;
  }

  const separatorIndex = rawVipParam.indexOf("=");
  const vipGwpParamName = rawVipParam.slice(0, separatorIndex).trim();
  const vipGwpParamValue = rawVipParam.slice(separatorIndex + 1).trim();

  if (!vipGwpParamName || !vipGwpParamValue) {
    return;
  }

  const sessionKey = `theme:vip-gwp:${rawVipParam}`;
  const sessionSyncKey = `${sessionKey}:synced`;
  let sessionToken = null;
  let sessionSynced = false;

  try {
    sessionToken = window.sessionStorage.getItem(sessionKey);
    sessionSynced = window.sessionStorage.getItem(sessionSyncKey) === "true";
  } catch (error) {
    sessionToken = null;
    sessionSynced = false;
  }

  const currentUrl = new URL(window.location.href);
  const matchedToken = currentUrl.searchParams.get(vipGwpParamName);
  const shouldGrantAccess =
    matchedToken === vipGwpParamValue || sessionToken === vipGwpParamValue;

  if (!shouldGrantAccess) {
    return;
  }

  try {
    window.sessionStorage.setItem(sessionKey, vipGwpParamValue);
  } catch (error) {
    // Session persistence is optional; cart attributes are the source of truth for Liquid.
  }

  if (
    gwpConfig.vipCartAttributeGranted === "true" &&
    gwpConfig.vipCartAttributeParam === rawVipParam
  ) {
    try {
      window.sessionStorage.setItem(sessionSyncKey, "true");
    } catch (error) {
      // Ignore sessionStorage write failures and rely on the cart attribute only.
    }

    return;
  }

  if (sessionSynced) {
    return;
  }

  window.GlowidCart.request(`${Shopify.routes.root}cart/update.js`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
    },
    keepalive: true,
    body: JSON.stringify({
      attributes: {
        _vip_gwp_access: "true",
        _vip_gwp_param: rawVipParam,
      },
    }),
  })
    .then(function (response) {
      if (!response.ok) {
        throw new Error("Failed to store VIP GWP access");
      }

      return response.json();
    })
    .then(function () {
      try {
        window.sessionStorage.setItem(sessionSyncKey, "true");
      } catch (error) {
        // Ignore sessionStorage write failures and rely on the cart attribute only.
      }

      document.documentElement.dispatchEvent(
        new CustomEvent("cart:refresh", {
          bubbles: true,
        }),
      );
    })
    .catch(function (error) {
      console.error("Error storing VIP GWP access:", error);
    });
});

document.addEventListener("DOMContentLoaded", function () {
  const width = document.documentElement.clientWidth;
  if (width < 641) {
    document.querySelectorAll(
      ".ImageHero__Video-Mobile, .ImageHero__Video-Mobile .ImageHero__Video-Player",
    ).forEach((element) => {
      element.style.minHeight = `${(width / 4) * 5}px`;
    });
  }

  setTimeout(function () {
    const giftContainer = document.getElementById("freegift");
    if (giftContainer) {
      giftContainer.append(...document.querySelectorAll(".freegift"));
    }
    document.querySelectorAll(".placeholder-image").forEach((element) => {
      const animation = element.animate({ opacity: [1, 0] }, { duration: 400 });
      animation.addEventListener("finish", () => {
        element.style.display = "none";
      }, { once: true });
    });
  }, 1000);
});

document.addEventListener("click", function (event) {
  const button = event.target.closest(".btn-git-cart");
  if (!button) return;
  button.closest(".gift-tier-container")?.querySelectorAll("product-form").forEach((form) => {
    form.classList.add("disable");
  });
});

// =============================================================================
// CART DRAWER COMPATIBILITY LAYER FOR THIRD-PARTY APPS
// =============================================================================
// This ensures apps like Quikify can still open the cart drawer programmatically
// even though the new theme uses a different cart drawer system

document.addEventListener("DOMContentLoaded", function () {
  // Function to open cart drawer programmatically
  function openCartDrawer() {
    const cartDrawer = document.querySelector("cart-drawer");
    if (cartDrawer && typeof cartDrawer.show === "function") {
      cartDrawer.show();
    }
  }

  // Legacy compatibility: Listen for old theme's drawer opening method
  // Apps like Quikify might try to trigger 'data-action="open-drawer"'
  document.addEventListener("click", function (e) {
    const target = e.target.closest('[data-action="open-drawer"]');
    if (target && target.getAttribute("data-drawer-id") === "sidebar-cart") {
      e.preventDefault();
      openCartDrawer();
    }
  });

  // Alternative method: Listen for custom events that apps might dispatch
  document.addEventListener("cart:drawer:open", function () {
    openCartDrawer();
  });

  // Global function that apps can call directly
  window.openCartDrawer = openCartDrawer;

  // Alternative global function using old theme naming
  window.theme = window.theme || {};
  window.theme.cart = window.theme.cart || {};
  window.theme.cart.openDrawer = openCartDrawer;

  console.log("Cart drawer compatibility layer loaded");
});

// Growave appearance: one discovery observer and one bounded readiness timer.
(() => {
  const ratingSelector = '.product-card__growave-rating--custom-size .gw-rv-listing-average-placeholder';
  const wishlistSelector = '.gw-wl-header-icon-placeholder';
  const hostSelector = `${ratingSelector}, ${wishlistSelector}`;
  const heart = 'M2 9.5a5.5 5.5 0 0 1 9.591-3.676.56.56 0 0 0 .818 0A5.49 5.49 0 0 1 22 9.5c0 2.29-1.5 4-3 5.5l-5.492 5.313a2 2 0 0 1-3 .019L5 15c-1.5-1.5-3-3.2-3-5.5';
  const pending = new Map();
  const seen = new WeakSet();
  let timer;

  function update(host) {
    if (!host.isConnected) return true;
    const rating = host.matches(ratingSelector);
    const root = host.shadowRoot || host;
    if (host.shadowRoot) {
      const id = rating ? 'product-card-growave-rating-custom-size' : 'gw-wl-header-icon-color-fix';
      if (!root.getElementById(id)) {
        const style = document.createElement('style');
        style.id = id;
        style.textContent = rating
          ? '.gw-rv-listing-average-reviews__count{font-size:12px;line-height:1}.gw-rv-avg-rating{column-gap:0.1em!important}.gw-rv-avg-rating__star,.gw-rv-avg-rating__star-half,.gw-rv-avg-rating__star-empty{width:14px!important;height:14px!important}'
          : 'svg{color:rgb(var(--text-color))!important}svg [fill]:not([fill="none"]){fill:currentColor!important}svg [stroke]:not([stroke="none"]){stroke:currentColor!important}';
        root.append(style);
      }
    }
    if (!rating) {
      root.querySelectorAll('svg.gw-wl-icon').forEach(svg => {
        const paths = svg.querySelectorAll('path');
        if (!paths.length || paths[0].getAttribute('d') === heart) return;
        svg.setAttribute('viewBox', '0 0 24 24');
        paths.forEach((path, index) => index ? path.remove() : path.setAttribute('d', heart));
        paths[0].setAttribute('stroke-linecap', 'round');
        paths[0].setAttribute('stroke-linejoin', 'round');
      });
    }
    return Boolean(host.shadowRoot || root.querySelector(rating
      ? '.gw-rv-listing-average-reviews__count, .gw-rv-avg-rating'
      : '.gw-wl-go-to-wishlist-header-widget'));
  }

  function checkPending() {
    timer = undefined;
    for (const [host, deadline] of pending) {
      if (update(host) || performance.now() >= deadline) pending.delete(host);
    }
    if (pending.size) timer = setTimeout(checkPending, 250);
  }

  function visit(host) {
    if (update(host)) pending.delete(host);
    else if (!seen.has(host)) pending.set(host, performance.now() + 10000);
    seen.add(host);
  }

  function scan(root) {
    if (!(root instanceof Element || root instanceof Document)) return;
    const host = root.closest?.(hostSelector);
    if (host) visit(host);
    root.querySelectorAll(hostSelector).forEach(visit);
  }

  function start() {
    scan(document);
    if (pending.size) timer = setTimeout(checkPending, 250);
    new MutationObserver(mutations => {
      const roots = new Set();
      for (const mutation of mutations) {
        if (mutation.type === 'attributes') {
          const host = mutation.target.closest(wishlistSelector);
          if (host) roots.add(host);
        } else {
          for (const node of mutation.addedNodes) if (node.nodeType === 1) roots.add(node);
        }
      }
      for (const root of roots) {
        let parent = root.parentElement;
        while (parent && !roots.has(parent)) parent = parent.parentElement;
        if (!parent) scan(root);
      }
      if (pending.size && timer === undefined) timer = setTimeout(checkPending, 250);
      else if (!pending.size) { clearTimeout(timer); timer = undefined; }
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['d'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();

// =============================================================================
// PREVENT CART DRAWER FROM CLOSING WHEN UPSELL POPOVER IS OPEN
// =============================================================================
// The cart drawer's focus trap detects clicks outside the drawer and closes it.
// When the pre-checkout upsell popover (lb-upsell-addon-popup) is visible, clicks
// on it would close the drawer before reaching the popover. This patches the
// drawer's hideForOutsideClickTarget method to ignore clicks inside the popover.
// =============================================================================
(function () {
  customElements.whenDefined("cart-drawer").then(function () {
    var drawer = document.getElementById("cart-drawer");
    if (!drawer) return;

    var originalHide = drawer.hideForOutsideClickTarget.bind(drawer);
    drawer.hideForOutsideClickTarget = function (target) {
      if (target && target.closest("lb-upsell-addon-popup")) {
        return false;
      }
      return originalHide(target);
    };

    var originalAllow = drawer.allowOutsideClickForTarget.bind(drawer);
    drawer.allowOutsideClickForTarget = function (target) {
      if (target && target.closest("lb-upsell-addon-popup")) {
        return true;
      }
      return originalAllow(target);
    };
  });
})();

// =============================================================================
// FREE SHIPPING METER (A/B test `cart-meter` — variant arm)
// =============================================================================
// Control is the legacy <free-shipping-bar> element in theme.js; the arms
// deliberately share no code. Markup: snippets/free-shipping-meter.liquid.
// Docs: docs/AB-TESTING.md.
(() => {
  class FreeShippingMeter extends HTMLElement {
    static get observedAttributes() {
      return ["total-price", "total-weight"];
    }

    connectedCallback() {
      this._onCartChange = (event) => {
        const cart = event.detail && event.detail.cart;
        if (!cart) return;
        const price =
          cart.items
            .filter((item) => item.requires_shipping)
            .reduce((sum, item) => sum + item.final_line_price, 0) -
          cart.cart_level_discount_applications.reduce(
            (sum, discount) => sum + discount.total_allocated_amount,
            0,
          );
        this.setAttribute("total-price", price);
        this.setAttribute("total-weight", cart.total_weight || 0);
      };
      document.addEventListener("cart:change", this._onCartChange);
      this._update();
    }

    disconnectedCallback() {
      document.removeEventListener("cart:change", this._onCartChange);
    }

    attributeChangedCallback() {
      this._update();
    }

    _update() {
      const messageElement = this.querySelector(".free-shipping-meter__message");
      if (!messageElement) return;

      // threshold attr is in minor units; 'gt' rules qualify strictly above it
      const threshold =
        (parseFloat(this.getAttribute("threshold")) || 0) +
        (this.getAttribute("comparison") === "gte" ? 0 : 1);
      const totalPrice = parseFloat(this.getAttribute("total-price")) || 0;
      const totalWeight = parseFloat(this.getAttribute("total-weight")) || 0;
      const maxWeight = parseFloat(this.getAttribute("max-weight")) || 0;

      if (maxWeight > 0 && totalWeight > maxWeight) {
        this.hidden = true;
        return;
      }
      this.hidden = false;

      const qualified = totalPrice >= threshold;
      const progress = Math.min(Math.max((totalPrice / threshold) * 100, 0), 100);

      this.toggleAttribute("qualified", qualified);
      this.style.setProperty("--free-shipping-progress", `${progress}%`);
      const progressbar = this.querySelector('[role="progressbar"]');
      if (progressbar) progressbar.setAttribute("aria-valuenow", Math.round(progress));

      if (qualified) {
        messageElement.innerHTML = this.getAttribute("reached-message");
      } else {
        const remaining = Math.max(threshold - totalPrice, 0);
        const formatted = new Intl.NumberFormat(Shopify.locale, {
          style: "currency",
          currency: Shopify.currency.active,
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        })
          .format(Math.ceil(remaining / 100))
          .replace(/\$/g, "$$$$");
        messageElement.innerHTML = this
          .getAttribute("unreached-message")
          .replace(/\[remaining_amount\]/g, formatted);
      }
    }
  }

  if (!window.customElements.get("free-shipping-meter")) {
    window.customElements.define("free-shipping-meter", FreeShippingMeter);
  }

  // Manual-trigger enrollment: the cart-meter test only enrolls visitors at
  // the moment they see their cart — opening the cart drawer, or landing on
  // the cart page (its gate carries data-ab-activate). Never-exposed
  // visitors would only dilute both arms.
  document.addEventListener("DOMContentLoaded", () => {
    if (!window.GlowidAB) return;
    const drawer = document.getElementById("cart-drawer");
    if (drawer) {
      drawer.addEventListener(
        "dialog:after-show",
        () => window.GlowidAB.activate("cart-meter"),
        { once: true },
      );
    }
    if (document.querySelector('[data-ab-test="cart-meter"][data-ab-activate]')) {
      window.GlowidAB.activate("cart-meter");
    }
  });
})();

// ---------------------------------------------------------------------------
// mobile-nav-menu A/B test — variant-arm behaviour. Remove with the test
// (see snippets/ab-tests.liquid, docs/AB-TESTING.md).
//
// 1. Manual-trigger enrollment: visitors enroll the first time the
//    navigation drawer opens (the only place the arms differ), so desktop
//    and never-opens-the-menu traffic does not dilute the sample. The
//    decision is asked for before the open animation so the gated root
//    level is normally decided by the time the drawer is visible.
// 2. Softer reveal: the theme staggers drawer rows in with a 150 ms fade
//    every 100 ms, so each row pops. For the variant only, rows fade over
//    a longer time with a tighter gap, so the fades overlap and read as
//    one smooth sweep. Same Motion helpers (imported via the theme's import
//    map) and same structure as theme.js — only the timing differs.
//    Control keeps the theme's animation untouched.
// ---------------------------------------------------------------------------
(() => {
  const HANDLE = "mobile-nav-menu";
  const ROW = { duration: 0.35, gap: 0.05, easing: "ease-out", offset: 6 };

  document.addEventListener("DOMContentLoaded", async () => {
    const sidebar = document.getElementById("sidebar-menu");
    if (!sidebar || !window.GlowidAB) return;

    sidebar.addEventListener(
      "dialog:before-show",
      () => window.GlowidAB.activate(HANDLE),
      { once: true },
    );

    const isVariant = () =>
      sidebar
        .querySelector(`[data-ab-test="${HANDLE}"]`)
        ?.getAttribute("data-ab-decided") === "variant";

    // Search in the drawer. The theme's <predictive-search> does the
    // fetching; this only shows/hides the results overlay. The field is
    // never focused programmatically (the drawer's focus trap already skips
    // initial focus on touch devices), so opening the menu does not raise
    // the keyboard. Leaving search (Avbryt, Escape, clearing the field, or
    // closing the drawer) hides the overlay; the menu underneath was never
    // unmounted, so it is exactly where the visitor left it. The field opts
    // out of the Cloud Search app (class cloud-search-disable in the Liquid)
    // so the app does not replace this with its own full-screen search.
    const mainPanel = sidebar.querySelector(".header-sidebar__main-panel");
    const searchGate = sidebar.querySelector(".ab-nav-search-gate");
    const subPanel = sidebar.querySelector(".header-sidebar__collapsible-panel");
    if (searchGate && subPanel) {
      // Keep the search layer tied to submenu state independently of the
      // drawer's reveal animations, including when a page is restored.
      const syncSearchVisibility = () => searchGate.classList.toggle(
        "is-submenu-open", subPanel.hasAttribute("aria-activedescendant"),
      );
      new MutationObserver(syncSearchVisibility).observe(subPanel, {
        attributes: true, attributeFilter: ["aria-activedescendant"],
      });
      sidebar.addEventListener("dialog:before-show", syncSearchVisibility);
      window.addEventListener("pageshow", syncSearchVisibility);
      syncSearchVisibility();
    }
    const searchForm = sidebar.querySelector(".ab-nav__search-form");
    const results = sidebar.querySelector(".ab-nav__results");
    if (mainPanel && searchForm && results) {
      const input = searchForm.elements.q;
      const cancel = searchForm.querySelector(".ab-nav__search-cancel");
      const setSearching = (on) => {
        mainPanel.classList.toggle("is-searching", on);
        results.hidden = !on;
        cancel.hidden = !on;
      };
      const leaveSearch = () => {
        input.value = "";
        results.querySelector('[slot="results"]').replaceChildren();
        setSearching(false);
        input.blur();
      };
      input.addEventListener("input", () => setSearching(input.value.trim() !== ""));
      input.addEventListener("keydown", (event) => {
        if (event.key === "Escape" && input.value !== "") {
          event.preventDefault();
          event.stopPropagation();
          leaveSearch();
        }
      });
      cancel.addEventListener("click", leaveSearch);
      sidebar.addEventListener("dialog:after-hide", leaveSearch);

      // The results section's "view all results" button is wired to the
      // header search form by id (form="predictive-search-form"), whose
      // field is empty here, so the theme blocks the submit. Submit the
      // drawer's own form instead.
      results.addEventListener("click", (event) => {
        const button = event.target.closest('button[form="predictive-search-form"]');
        if (!button) return;
        event.preventDefault();
        searchForm.requestSubmit();
      });

      // Fade under the search bar once the menu is scrolled (CSS reads
      // is-scrolled; the variant-only gradient is scoped there).
      const scroller = mainPanel.querySelector(".header-sidebar__scroller");
      const syncScrolled = () => mainPanel.classList.toggle("is-scrolled", scroller.scrollTop > 2);
      scroller.addEventListener("scroll", syncScrolled, { passive: true });
      sidebar.addEventListener("dialog:after-show", syncScrolled);
    }

    let motion;
    try {
      motion = await import("vendor");
      await Promise.all([
        customElements.whenDefined("header-sidebar"),
        customElements.whenDefined("header-sidebar-collapsible-panel"),
      ]);
    } catch (e) {
      return; // no import map / no Motion: keep the theme's animation
    }
    const { animate, timeline, stagger } = motion;
    const Sidebar = customElements.get("header-sidebar");
    const Panel = customElements.get("header-sidebar-collapsible-panel");

    const rowSegment = (elements, at) => [
      elements,
      {
        opacity: [0, 1],
        transform: [`translateY(${ROW.offset}px)`, "translateY(0)"],
      },
      {
        duration: ROW.duration,
        easing: ROW.easing,
        at,
        delay: window.themeVariables?.settings?.staggerMenuApparition
          ? stagger(ROW.gap)
          : 0,
      },
    ];

    // Root level. The theme starts the row sweep on dialog:after-show, i.e.
    // only once the 300 ms drawer slide has finished. For the variant the
    // sweep starts EARLY_DELAY into the slide (from dialog:before-show), and
    // the after-show call reuses that running animation instead of
    // restarting it. Back-from-sub-panel keeps a short delay so the leaving
    // panel has faded before the root rows rise.
    const EARLY_DELAY = 0.2;
    const revealVariant = (el, delay) =>
      timeline([
        [
          el.querySelector(".header-sidebar__main-panel"),
          { opacity: 1, transform: "translateX(0)" },
          { duration: 0, at: delay },
        ],
        rowSegment(
          el.querySelectorAll(
            '[data-ab-arm="variant"] .ab-nav__search, [data-ab-arm="variant"] .header-sidebar__linklist li, [data-ab-arm="variant"] .ab-nav__heading',
          ),
          delay,
        ),
        [
          el.querySelector(".header-sidebar__footer"),
          { opacity: [0, 1], transform: ["translateY(10px)", "translateY(0)"] },
          { duration: 0.3 },
        ],
      ]);

    const originalReveal = Sidebar.prototype.revealItems;
    Sidebar.prototype.revealItems = function (withDelay = false) {
      if (!isVariant()) return originalReveal.call(this, withDelay);
      if (!withDelay && this.abEarlyReveal) {
        const running = this.abEarlyReveal;
        this.abEarlyReveal = null;
        return running;
      }
      return revealVariant(this, withDelay ? 0.3 : 0);
    };

    // The arm decision for a manual-trigger test resolves a microtask after
    // the activate() call above, so it is not known synchronously inside
    // before-show: wait for it. On a slow first-ever open (Shoplift still
    // answering) the decision can land after after-show; then the theme's
    // reveal has already run and nothing extra is started.
    let opening = false;
    sidebar.addEventListener("dialog:before-show", () => {
      opening = true;
      window.GlowidAB.variant(HANDLE).then((arm) => {
        if (arm !== "variant" || !opening) return;
        sidebar.abEarlyReveal = revealVariant(sidebar, EARLY_DELAY);
      });
    });
    sidebar.addEventListener("dialog:after-show", () => {
      opening = false;
    });

    // Sub-panels reachable from the variant root. The theme's panel switch
    // lives in a lifecycle callback bound at define time, so it cannot be
    // overridden; instead, watch the panel's `hidden` attribute, which the
    // theme clears right before starting its own stagger. Motion cancels an
    // element's running animation when a new one starts on the same
    // property, so the timeline started here replaces the theme's.
    sidebar.querySelectorAll(".header-sidebar__sub-panel.ab-nav-panel").forEach((panel) => {
      new MutationObserver(() => {
        if (panel.hidden) return;
        const mobile = window.matchMedia(window.themeVariables.mediaQueries["md-max"]).matches;
        const rows = mobile
          ? ".header-sidebar__back-button, .header-sidebar__linklist li, .ab-nav-panel__quiz"
          : ".header-sidebar__linklist li, .ab-nav-panel__quiz";
        timeline([rowSegment(panel.querySelectorAll(rows))]);
      }).observe(panel, { attributes: true, attributeFilter: ["hidden"] });
    });
  });
})();

// =============================================================================
// DOUBLE YOUR ORDER — STOREFRONT MARKER (cart attribute)
// =============================================================================
// The "double your order" Cart Transform (custom app) only expands carts that
// the website opted in with the cart attribute `_glowid_storefront = "true"`
// (or lines carrying it as a property — see snippets/double-order-marker.liquid).
// Staff orders created in Shopify Admin have no marker and stay untouched.
//
// Lines added through the theme's product forms carry the line marker, so
// this cart-level marker matters for carts that predate the rollout and for
// lines added by third-party apps. cart/update.js merges attributes, so other
// attributes (_vip_gwp_*, _gift_wrap_*, grid modes) are preserved.
//
// The cart forms (drawer + cart page) also submit the attribute as a hidden
// input, so the ordinary checkout button never depends on this request and
// always stays available. Accelerated checkout buttons on the cart page bypass
// the form: main-cart.liquid renders their container `inert` (no pointer,
// keyboard or focus activation) whenever the cart is unmarked, and it stays so
// until a cart response confirms the attribute. On failure or timeout a retry
// control is shown next to them.
(function () {
  var MARKER_KEY = "_glowid_storefront";
  var MARKER_VALUE = "true";
  var GATE_SELECTOR = ".additional-checkout-buttons";
  var RETRY_CLASS = "double-order-express-retry";
  var REQUEST_TIMEOUT_MS = 8000;

  var confirmed =
    window.themeVariables?.doubleOrder?.storefrontMarker === MARKER_VALUE;
  var failed = false;
  var inFlight = null;

  function isMarked(attributes) {
    return Boolean(attributes) && attributes[MARKER_KEY] === MARKER_VALUE;
  }

  function buildRetry() {
    var strings = window.themeVariables?.strings || {};
    var wrapper = document.createElement("div");
    wrapper.className = RETRY_CLASS + " text-sm text-subdued";
    wrapper.setAttribute("role", "status");

    var text = document.createElement("span");
    text.textContent =
      strings.doubleOrderExpressUnavailable ||
      "Express checkout is temporarily unavailable.";

    var button = document.createElement("button");
    button.type = "button";
    button.className = "link";
    button.textContent = strings.doubleOrderRetry || "Try again";
    button.addEventListener("click", function () {
      persistMarker();
    });

    wrapper.appendChild(text);
    wrapper.appendChild(document.createTextNode(" "));
    wrapper.appendChild(button);
    return wrapper;
  }

  // Applies the current state to every accelerated-checkout container on the
  // page. Re-run whenever the DOM changes: Shopify injects the buttons
  // asynchronously and the cart sections re-render on every cart change.
  function applyGate() {
    document.querySelectorAll(GATE_SELECTOR).forEach(function (container) {
      container.toggleAttribute("inert", !confirmed || Boolean(window.GlowidCart?.busy));
      container.toggleAttribute("aria-busy", !confirmed && !failed);

      var sibling = container.nextElementSibling;
      var retry =
        sibling && sibling.classList.contains(RETRY_CLASS) ? sibling : null;

      if (failed && !confirmed) {
        if (!retry) {
          container.insertAdjacentElement("afterend", buildRetry());
        }
      } else if (retry) {
        retry.remove();
      }
    });
  }

  function settle(ok) {
    if (ok) {
      confirmed = true;
      failed = false;
    } else {
      failed = true;
    }
    applyGate();
  }

  function persistMarker() {
    if (confirmed) {
      return Promise.resolve(true);
    }
    if (inFlight) {
      return inFlight;
    }

    failed = false;
    applyGate();

    var controller =
      typeof AbortController === "function" ? new AbortController() : null;
    var timer = window.setTimeout(function () {
      if (controller) controller.abort();
    }, REQUEST_TIMEOUT_MS);

    var attributes = {};
    attributes[MARKER_KEY] = MARKER_VALUE;

    inFlight = window.GlowidCart.request(Shopify.routes.root + "cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      keepalive: true,
      signal: controller ? controller.signal : undefined,
      body: JSON.stringify({ attributes: attributes }),
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error("cart/update.js responded " + response.status);
        }
        return response.json();
      })
      .then(function (cart) {
        // Only the returned cart counts as confirmation.
        settle(isMarked(cart && cart.attributes));
        return confirmed;
      })
      .catch(function (error) {
        console.error("Error storing the double-order storefront marker:", error);
        settle(false);
        return false;
      })
      .then(function (result) {
        window.clearTimeout(timer);
        inFlight = null;
        return result;
      });

    return inFlight;
  }

  document.addEventListener("cart:busy", applyGate);

  document.addEventListener("DOMContentLoaded", function () {
    applyGate();
    if (!confirmed) {
      persistMarker();
    }

    var scheduled = false;
    new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      window.queueMicrotask(function () {
        scheduled = false;
        applyGate();
      });
    }).observe(document.body, { childList: true, subtree: true });
  });

  // Every cart mutation in the theme dispatches cart:change with the cart JSON.
  // Shopify drops attributes when a cart is emptied, so a cart rebuilt in the
  // same page view is marked again here without waiting for a page load.
  document.addEventListener("cart:change", function (event) {
    var cart = event.detail && event.detail.cart;
    if (!cart || !cart.attributes) {
      return;
    }
    if (isMarked(cart.attributes)) {
      settle(true);
    } else {
      // Re-gate right away: persistMarker() returns early while a request is
      // already pending, and that request alone must not leave the buttons open.
      confirmed = false;
      failed = false;
      applyGate();
      persistMarker();
    }
  });

  window.GlowidDoubleOrder = {
    persistStorefrontMarker: persistMarker,
    isStorefrontMarkerConfirmed: function () {
      return confirmed;
    },
  };
})();
